//./src/index.js
// lib/laiiva-color-picker.umd.min.js
import "element-plus/theme-chalk/el-popover.css"
import 'element-plus/theme-chalk/el-progress.css';
import preset from '@qcolor/preset';
import create from '@qcolor/create';

export * from '@qcolor/components';
export {
  preset as default,
  preset as install,
  create,
};